import { facadeApi } from 'api'
import { AZUser } from 'types/users/users'

export const fetchAzUserByEmailApi = (email: string) => facadeApi.get<AZUser>(`/az/users/email/${email}`)
